export default {
  titleTips:'温馨提示',
  unsubscribe:'取消订阅',
  unsubscribeTips:'暂无退订信息',
  emailTips:'缺少邮箱地址',
  unsubscribeConfirm:'是否确认取消订阅',
  confirm:'确认',
  cancel:'取消',
  unsubscribeSuccessful:'退订成功',
  unsubscribeFailed:'退订失败',
  canceled:'已取消',
};
